angular.module('EdxSchoolReportModule')
  .controller('EdxSchoolReportController', [
    '$scope',
    '$state',
    'edxStateParamsService',
    'schoolApi',
    'timeframe',
    function (
      $scope,
      $state,
      edxStateParamsService,
      schoolApi,
      timeframe) {

      var params = _.pick($state.params, ['districtId']);
      params.school_id = $state.params.schoolId;
      params.grade_id = $state.params.gradeId || undefined;
      params = _.extend(params, edxStateParamsService.getTimeframeParamsForEarlyHighlights());

      schoolApi.getSchoolHighlights(params).then(function (schoolData) {
         timeframe.getYearListSubject().onNext(schoolData.years);

         // deprecated: use timeframe.getYearListSubject instead of broadcast
         $scope.$broadcast('updateYears', schoolData.years);

         return schoolData;
      });
    }
  ]);
